<template>
  <section>
    <scroll-container
      class="pt-2 mt-n30px"
      :height-offset="isInEditMode ? '55px' : '125px'"
    >
      <b-row v-if="loading">
        <b-col
          sm="12"
          class="text-center"
        >
          <b-skeleton
            class="d-inline-block"
            animation="wave"
            width="40%"
            height="700px"
          />
        </b-col>
      </b-row>
      <b-container
        v-else
        class="container-small"
      >
        <b-card
          v-if="isInEditMode"
          class="mb-2"
        >
          <div class="mb-2">
            <b-card-title class="mb-0">
              {{ $tk('ClientPortal.Form.EditDisplayAdSurvey') }}
            </b-card-title>
            <b-breadcrumb class="m-0 p-0">
              <b-breadcrumb-item :to="`/${$route.params.accountId}/campaign/edit/${wrapper.campaignModel.id}`">
                {{ wrapper.campaignModel.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item :to="`/${$route.params.accountId}/adgroup/edit?adGroupId=${wrapper.adGroup.id}&campaignId=${wrapper.campaignModel.id}`">
                {{ wrapper.adGroup.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ wrapper.displayAdEdit.adName }}
              </b-breadcrumb-item>
            </b-breadcrumb>
            <hr class="m-0 mt-1">
          </div>
          <!-- <b-card-title>
            {{ $tk('ClientPortal.Form.AdCreation.SurveyAds') }}
          </b-card-title> -->
          <b-form-group
            class="mb-2"
            :invalid-feedback="wrapper.displayAdEdit.errors['FormatId']"
            :state="wrapper.displayAdEdit.errors['FormatId'] == null ? null : false"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.AdCreation.AdFormats') }} *
              <GjIcon
                v-b-tooltip.hover="$tk('ClientPortal.Form.AdFormatsTooltip')"
                name="Info"
              />
            </legend>
            <b-form-row>
              <b-col :sm="surveyLength ? 11 : 12">
                <b-form-group
                  :state="wrapper.displayAdEdit.errors['FormatId'] == null ? null : false"
                >
                  <v-select
                    id="FormatId"
                    v-model="wrapper.displayAdEdit.formatId"
                    :clearable="false"
                    label="name"
                    :options="wrapper.adFormats"
                    :reduce="format => format.id"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdCreation.BackgroundImage(ThisFileShouldNotBeLargerThan4MB)')"
            label-size="sm"
            label-class="pb-50"
          >
            <vue-dropzone
              id="dropzone"
              ref="imageDropzone"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              class="w-100"
              @vdropzone-success="uploadFile"
              @vdropzone-processing="dropzoneChangeUrl"
              @vdropzone-thumbnail="checkFileThumbnail"
              @vdropzone-complete="removeFile($event)"
            >
              <div class="dz-default dz-message dz-message-center mx-3">
                <b-button
                  variant="outline-primary"
                  class="bg-white mr-2"
                  size="sm"
                >
                  <GjIcon
                    class="mr-50"
                    name="Hyperlink"
                  />
                  {{ $tk('ClientPortal.Form.UploadFiles') }}
                </b-button>
              </div>
            </vue-dropzone>
            <span
              v-if="uploadMessageEditMode"
              :class="(uploadMessageEditMode.results.filter(el => el.inserted === false).length) === 0 && uploadMessageEditMode.results.length !== 0 ? 'text-success' : 'text-danger'"
              class="field-validation-valid small"
            >
              {{ uploadMessageEditMode.message }}
            </span>
          </b-form-group>
          <b-form-group
            id="AdName"
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdName') + ' *'"
            :invalid-feedback="wrapper.displayAdEdit.errors['AdName']"
            :state="wrapper.displayAdEdit.errors['AdName'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <AdNameField
                  :id="'ad-name-'+wrapper.displayAdEdit.id"
                  v-model="wrapper.displayAdEdit.adName"
                  :variables="adNameVariables"
                  :placeholder="$tk('ClientPortal.Form.AdNamePlaceholder')"
                  :state="wrapper.displayAdEdit.errors['AdName'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(wrapper.displayAdEdit.id,'name')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>

          <b-form-group
            class="mb-2"
            :invalid-feedback="wrapper.displayAdEdit.errors['Subtype']"
            :state="wrapper.displayAdEdit.errors['Subtype'] == null ? null : false"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.ChooseSurvey') }} *
              <GjIcon name="Info" />
            </legend>
            <b-form-group
              :state="wrapper.displayAdEdit.errors['Subtype'] == null ? null : false"
            >
              <v-select
                id="Subtype"
                v-model="wrapper.displayAdEdit.surveyId"
                :clearable="false"
                label="name"
                :options="wrapper.surveysList"
                :reduce="survey => survey.id"
              />
            </b-form-group>
          </b-form-group>
          <hr>
          <div class="text-center my-2">
            <b-button
              variant="outline-primary"
              size="sm"
              :to="`/${$route.params.accountId}/surveys/create/`"
              target="_blank"
            >
              <GjIcon
                name="Plus"
                class="mr-50"
              />
              {{ $tk('ClientPortal.Form.CreateNewSurvey') }}
            </b-button>
          </div>
          <b-form-group
            class="mb-0"
            :label="$tk('ClientPortal.Form.ImpressionTag')"
          >
            <b-form-row>
              <b-col sm="11">
                <b-form-input
                  :id="'ad-imp-'+wrapper.displayAdEdit.id"
                  v-model="wrapper.displayAdEdit.impressionTag"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.ImpressionTagTooltip')"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(wrapper.displayAdEdit.id,'imp')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-card-title
            v-b-toggle="`collapse-ad-preview-${wrapper.displayAdEdit.id}`"
            class="d-flex justify-content-between py-2 mb-0"
            @click="showDisplayAd(wrapper.displayAdEdit)"
          >
            <div
              class="text-primary d-flex align-items-center"
            >
              <GjIcon name="Show" />
              {{ $tk('ClientPortal.Form.AdCreation.EndImagePreview') }}
            </div>
            <span class="when-open">
              <GjIcon name="ArrowUp" />
            </span>
            <span class="when-closed">
              <GjIcon name="ArrowDown" />
            </span>
          </b-card-title>
          <b-collapse
            :id="`collapse-ad-preview-${wrapper.displayAdEdit.id}`"
          >
            <PreviewImageAd
              :preview-ad="wrapper.displayAdEdit.show"
              :url="wrapper.displayAdEdit.mediaUrl"
            />
          </b-collapse>
        </b-card>
        <b-card
          v-for="(displayAd, index) in wrapper.displayAds"
          v-else
          :key="index"
          class="mb-2"
        >
          <div
            v-if="index === 0"
            class="mb-2"
          >
            <b-card-title class="mb-0">
              {{ $tk('ClientPortal.Form.NewDisplayAdSurvey') }}
            </b-card-title>
            <b-breadcrumb class="m-0 p-0">
              <b-breadcrumb-item :to="`/${$route.params.accountId}/campaign/create/${wrapper.campaignModel.id}`">
                {{ wrapper.campaignModel.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item :to="`/${$route.params.accountId}/adgroup/create?adGroupId=${wrapper.adGroup.id}&campaignId=${wrapper.campaignModel.id}`">
                {{ wrapper.adGroup.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ $tk('ClientPortal.Form.NewAd') }}
              </b-breadcrumb-item>
            </b-breadcrumb>
            <hr class="m-0 mt-1">
          </div>
          <!-- <b-card-title>
            {{ $tk('ClientPortal.Form.AdCreation.SurveyAds') }}
          </b-card-title> -->
          <b-form-group
            class="mb-2"
            :invalid-feedback="displayAd.errors['FormatId']"
            :state="displayAd.errors['FormatId'] == null ? null : false"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.AdCreation.AdFormats') }} *
              <GjIcon
                v-b-tooltip.hover="$tk('ClientPortal.Form.AdFormatsTooltip')"
                name="Info"
              />
            </legend>
            <b-form-row>
              <b-col :sm="surveyLength ? 11 : 12">
                <b-form-group
                  :state="displayAd.errors['FormatId'] == null ? null : false"
                >
                  <v-select
                    id="FormatId"
                    v-model="displayAd.formatId"
                    :clearable="false"
                    label="name"
                    :placeholder="$tk('ClientPortal.Form.ChooseAdFormat')"
                    :options="wrapper.adFormats"
                    :reduce="format => format.id"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="surveyLength"
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="removeDisplayAd(displayAd.id)"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Delete"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdCreation.EndImage(ThisFileShouldNotBeLargerThan4MB)')"
            label-size="sm"
            label-class="pb-50"
          >
            <vue-dropzone
              id="dropzone"
              ref="imageDropzone"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              class="w-100"
              @vdropzone-success="uploadFile($event,$event.xhr.response,index)"
              @vdropzone-thumbnail="checkFileThumbnail"
              @vdropzone-processing="dropzoneChangeUrl"
              @vdropzone-complete="removeFile($event,index)"
            >
              <div class="dz-default dz-message dz-message-center mx-3">
                <b-button
                  variant="outline-primary"
                  class="bg-white mr-2"
                  size="sm"
                >
                  <GjIcon
                    class="mr-50"
                    name="Hyperlink"
                  />
                  {{ $tk('ClientPortal.Form.UploadSurveyEndImage') }}
                </b-button>
              </div>
            </vue-dropzone>
            <span
              v-if="uploadMessage[index]"
              :class="(uploadMessage[index].results.filter(el => el.inserted === false).length) === 0 && uploadMessage[index].results.length !== 0 ? 'text-success' : 'text-danger'"
              class="field-validation-valid small"
            >
              {{ uploadMessage[index].message }}
            </span>
          </b-form-group>
          <b-form-group
            id="AdName"
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdName') + ' *'"
            :invalid-feedback="displayAd.errors['AdName']"
            :state="displayAd.errors['AdName'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <AdNameField
                  :id="'ad-name-'+displayAd.id"
                  v-model="displayAd.adName"
                  :variables="adNameVariables"
                  :placeholder="$tk('ClientPortal.Form.AdNamePlaceholder')"
                  :state="displayAd.errors['AdName'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(displayAd.id,'name')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>

          <b-form-group
            class="mb-2"
            :invalid-feedback="displayAd.errors['Subtype']"
            :state="displayAd.errors['Subtype'] == null ? null : false"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.ChooseSurvey') }} *
              <GjIcon name="Info" />
            </legend>
            <b-form-group
              :state="displayAd.errors['Subtype'] == null ? null : false"
            >
              <v-select
                id="Subtype"
                v-model="displayAd.surveyId"
                :clearable="false"
                label="name"
                :placeholder="$tk('ClientPortal.Form.ChooseSurvey')"
                :options="wrapper.surveysList"
                :reduce="survey => survey.id"
              />
            </b-form-group>
          </b-form-group>
          <hr>
          <div class="text-center my-2">
            <b-button
              variant="outline-primary"
              :to="`/${$route.params.accountId}/surveys/create/`"
              target="_blank"
              size="sm"
            >
              <GjIcon
                name="Plus"
                class="mr-50"
              />
              {{ $tk('ClientPortal.Form.CreateNewSurvey') }}
            </b-button>
          </div>
          <b-form-group
            class="mb-0"
            :label="$tk('ClientPortal.Form.ImpressionTag')"
          >
            <b-form-row>
              <b-col sm="11">
                <b-form-input
                  :id="'ad-imp-'+displayAd.id"
                  v-model="displayAd.impressionTag"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.ImpressionTagPlaceholder')"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(displayAd.id,'imp')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-card-title
            v-b-toggle="`collapse-ad-preview-${displayAd.id}`"
            class="d-flex justify-content-between py-2 mb-0"
            @click="showDisplayAd(displayAd)"
          >
            <div
              class="text-primary d-flex align-items-center"
            >
              <GjIcon name="Show" />
              {{ $tk('ClientPortal.Form.AdCreation.EndImagePreview') }}
            </div>
            <span class="when-open">
              <GjIcon name="ArrowUp" />
            </span>
            <span class="when-closed">
              <GjIcon name="ArrowDown" />
            </span>
          </b-card-title>
          <b-collapse
            :id="`collapse-ad-preview-${displayAd.id}`"
          >
            <PreviewImageAd
              :preview-ad="displayAd.show"
              :url="displayAd.mediaUrl"
            />
          </b-collapse>
        </b-card>
        <b-button
          v-if="!isInEditMode"
          class="bg-white mb-3"
          size="sm"
          variant="outline-primary"
          @click="addDefaultSurveyAd()"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Form.Actions.AddSurveyAd') }}
        </b-button>
      </b-container>
    </scroll-container>

    <div class="border-top text-right py-1">
      <div class="container-small mx-auto">
        <b-button
          v-if="isInEditMode"
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          @click="closeEditModal"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          v-else
          :to="`/${$route.params.accountId}`"
          class="bg-white"
          variant="outline-dark"
          :disabled="saving"
          size="sm"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="bg-white ml-50"
          variant="primary"
          size="sm"
          :disabled="saving || !isFormComplete"
          @click="saveDisplayAd()"
        >
          {{ isInEditMode ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.CreateAd') }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import vue2Dropzone from 'vue2-dropzone'
import notification from '@/mixins/toastification'
import sweetAlert from '@/mixins/sweetAlert'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ScrollContainer from '@/components/ScrollContainer.vue'
import getAPIDomain from '@/utils/apiDomain/apiDomain'
import AdsService from '@/api/client/ads.service'
import PreviewImageAd from '@/components/PreviewImageAd.vue'
import scrollToError from '@/mixins/scrollToError'
import vSelect from 'vue-select'
import AdNameField from '@/components/AdNameField.vue'
import { AD_NAME_VARIABLES, findUnknownTokens } from '@/utils/adNameTokens'

const ADSUBTYPE_SURVEY_DISPLAY_AD = 8
export default {
  inject: ['closeEditModal'],
  components: {
    GjIcon,
    vueDropzone: vue2Dropzone,
    ScrollContainer,
    PreviewImageAd,
    vSelect,
    AdNameField,
  },
  mixins: [notification, sweetAlert],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    adId: Number,
    // eslint-disable-next-line vue/require-default-prop
    adGroupId: Number,
    // eslint-disable-next-line vue/require-default-prop
    catalogSetId: {
      type: String,
    },
    saving: {
      type: Boolean,
    },
  },
  data() {
    return {
      wrapper: {},
      adFormats: [],
      count: 1,
      uploadMessage: [''],
      uploadMessageEditMode: '',
      temporaryImage: '',
      dropzoneOptions: {
        uploadMultiple: false,
        maxFiles: 1,
        acceptedFiles: '.jpg,.png,.jpeg,.gif',
        url: 'url',
        thumbnailWidth: null,
        timeout: 60000,
        thumbnailHeight: null,
        addRemoveLinks: true,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
      loading: false,
    }
  },
  computed: {
    surveyLength() {
      return this.wrapper.displayAds.length > 1
    },
    isFormComplete() {
      if (this.isInEditMode) {
        const { displayAdEdit } = this.wrapper
        return displayAdEdit && displayAdEdit.formatId && displayAdEdit.adName && displayAdEdit.surveyId
      }
      return this.wrapper.displayAds && this.wrapper.displayAds.every(x => x.formatId && x.adName && x.surveyId)
    },
    isInEditMode() {
      return this.adId > 0
    },
    adNameVariables() {
      return AD_NAME_VARIABLES
    },
  },
  async mounted() {
    this.loading = true
    try {
      this.wrapper = await AdsService.getAd(this.adId, this.adGroupId, this.catalogSetId, this.$route.params.accountId)
    } catch (error) {
      this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
    } finally {
      this.addDefaultSurveyAd()
      this.loading = false
    }
  },
  methods: {
    setSaving(value) {
      this.$emit('onUpdate', value)
    },
    dropzoneChangeUrl() {
      const clientApi = getAPIDomain()
      const { accountId } = this.$route.params

      if (Array.isArray(this.$refs.imageDropzone)) {
        this.$refs.imageDropzone.forEach(x => x.setOption('url', `${clientApi}/upload/ad?subtype=${ADSUBTYPE_SURVEY_DISPLAY_AD}&accountId=${accountId}`))
      } else {
        this.$refs.imageDropzone.setOption('url', `${clientApi}/upload/ad?subtype=${ADSUBTYPE_SURVEY_DISPLAY_AD}&accountId=${accountId}`)
      }
    },
    showDisplayAd(displayAd) {
      if (displayAd.mediaUrl === '') {
        displayAd.show = false
      } else {
        displayAd.show = true
      }
    },
    removeDisplayAd(id) {
      if (this.wrapper.displayAds.length > 1) {
        const index = this.wrapper.displayAds.findIndex(x => x.id === id)
        if (index > -1) {
          this.wrapper.displayAds.splice(index, 1)
          this.uploadMessage.splice(index, 1)
        }
      }
    },
    copyText(id, type) {
      const element = `ad-${type}-${id}`
      const copyText = document.getElementById(element)
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    validateAdName(ad) {
      if (!ad.errors) this.$set(ad, 'errors', {})
      this.$set(ad.errors, 'AdName', null)
      const unknown = findUnknownTokens(ad.adName)
      if (unknown.length > 0) {
        const tokens = unknown.map(k => `{{${k}}}`).join(', ')
        this.$set(ad.errors, 'AdName', `Unknown variables: ${tokens}`)
        return false
      }
      return true
    },
    async saveDisplayAd() {
      this.setSaving(true)

      if (this.isInEditMode) {
        if (!this.validateAdName(this.wrapper.displayAdEdit)) {
          this.setSaving(false)
          this.$nextTick(() => scrollToError(this.wrapper.displayAdEdit.errors))
          return
        }
        const { entity } = this.$parent.$parent.$parent
        this.escapeImpressionAndExternalContent([this.wrapper.displayAdEdit])
        try {
          const response = await AdsService.editDisplayAd(this.wrapper.displayAdEdit, this.$route.params.accountId)
          if (response.updated) {
            const resolvedName = response.adName || (response.displayAdModel && response.displayAdModel.adName) || this.wrapper.displayAdEdit.adName
            this.wrapper.displayAdEdit.adName = resolvedName
            entity.name = resolvedName
            this.success(response.message)
            this.closeEditModal()
          } else {
            this.error(response.message)
            this.wrapper.displayAdEdit = response.displayAdModel
            this.$nextTick(() => {
              scrollToError(this.wrapper.displayAdEdit.errors)
            })
          }
        } catch (error) {
          this.error(error.message)
        } finally {
          this.setSaving(false)
        }
      } else if (this.wrapper.displayAds.length > 0) {
        let hasInvalid = false
        this.wrapper.displayAds.forEach(ad => {
          if (!this.validateAdName(ad)) hasInvalid = true
        })
        if (hasInvalid) {
          this.$nextTick(() => {
            const firstInvalidInput = document.querySelector('.is-invalid')
            if (firstInvalidInput) {
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.setSaving(false)
          return
        }
        this.escapeImpressionAndExternalContent(this.wrapper.displayAds)
        try {
          const response = await AdsService.createDisplayAd(ADSUBTYPE_SURVEY_DISPLAY_AD, this.wrapper.displayAds, this.$route.params.accountId)
          if (response.saved) {
            this.wrapper.displayAds = []
            this.sweetAlertAfterAdCreation()
          } else {
            this.wrapper.displayAds = response.displayAds
            this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
            this.$nextTick(() => {
              const firstInvalidInput = document.querySelector('.is-invalid')
              if (firstInvalidInput) {
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }
            })
            this.setSaving(false)
          }
        } catch (error) {
          this.error(error.message)
          this.setSaving(false)
        }
      }
    },
    escapeImpressionAndExternalContent(displayAds) {
      displayAds.forEach(element => {
        element.impressionTag = escape(element.impressionTag)
        element.externalContent = escape(element.externalContent)
      })
    },
    addDefaultSurveyAd() {
      this.wrapper.displayAds.push(
        {
          id: this.count,
          adName: '',
          mediaUrl: '',
          url: '',
          formatId: this.wrapper.adFormats[0].id,
          adGroupId: this.wrapper.adGroup.id,
          externalContent: '',
          impressionTag: '',
          show: false,
          errors: {},
        },
      )
      // eslint-disable-next-line no-plusplus
      this.count++
    },
    fileFormatCheck(height, width) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.wrapper.adFormats.length; i++) {
        if (this.wrapper.adFormats[i].width === width && this.wrapper.adFormats[i].height === height) return true
      }
      return false
    },
    checkFileThumbnail(file) {
      this.setSaving(true)
      const imageFormatExists = this.fileFormatCheck(file.height, file.width)
      if (imageFormatExists === true) {
        // eslint-disable-next-line no-undef
        file.acceptDimensions = () => done
      }
    },
    uploadFile(file, response, adIndex = 0) {
      let responseObj
      if (!this.isInEditMode) {
        responseObj = JSON.parse(response)
      } else {
        responseObj = response
      }
      this.uploadMessage[adIndex] = ''
      const imageFormatExists = this.fileFormatCheck(file.height, file.width)
      if (imageFormatExists === true) {
        responseObj.results.forEach(element => {
          if (element.inserted) {
            // const index = this.wrapper.displayAds.findIndex(x => x.mediaUrl === element.imageLink)
            this.temporaryImage = element.imageLink
          }
        })
      }
      if (!responseObj.success) {
        if (this.isInEditMode) {
          this.uploadMessageEditMode = responseObj
        } else {
          this.uploadMessage[adIndex] = responseObj
        }
      }
      this.setSaving(false)
    },
    removeFile(file, index) {
      if (this.isInEditMode) {
        this.wrapper.displayAdEdit.mediaUrl = this.temporaryImage
        this.$refs.imageDropzone.removeFile(file)
      } else {
        this.wrapper.displayAds[index].mediaUrl = this.temporaryImage
        this.$refs.imageDropzone[index].removeFile(file)
      }
    },
  },
}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss">
  #dropzone {
    border-radius: 0.25rem;
    border: 2px dashed #e5e5e5;
    padding: 0;
    .dz-message {
      margin: 3.9em 0;
    }
    .dz-details {
      background-color: unset;
    }
  }
</style>
